
import cfImage from '@/utils/cfImage'

const IMG_BASE = 'https://blog.flightsearchdirect.com/wp-content/uploads/2023/11'

export default {
  methods: {
    cfImage,
    prefillSearch (payload) {
      this.$store.commit('setSearchFormPrefill', payload)
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  },
  data () {
    return {
      confidenceCards: [
        { key: 'direct', icon: '🎯' },
        { key: 'options', icon: '🔀' },
        { key: 'availability', icon: '🔄' }
      ],
      whoCards: [
        { key: 'business', icon: '💼' },
        { key: 'family', icon: '👨‍👩‍👧‍👦' },
        { key: 'solo', icon: '🎒' },
        { key: 'frequent', icon: '✈️' }
      ],
      routes: [
        { from: 'TLV', to: 'JFK', fromName: 'Tel Aviv', toName: 'New York', img: `${IMG_BASE}/new-york.jpg` },
        { from: 'TLV', to: 'LHR', fromName: 'Tel Aviv', toName: 'London', img: `${IMG_BASE}/london.jpg` },
        { from: 'TLV', to: 'CDG', fromName: 'Tel Aviv', toName: 'Paris', img: `${IMG_BASE}/paris.jpg` },
        { from: 'TLV', to: 'FCO', fromName: 'Tel Aviv', toName: 'Rome', img: `${IMG_BASE}/rome.jpg` },
        { from: 'TLV', to: 'BCN', fromName: 'Tel Aviv', toName: 'Barcelona', img: `${IMG_BASE}/barcelona.jpg` },
        { from: 'TLV', to: 'ATH', fromName: 'Tel Aviv', toName: 'Athens', img: `${IMG_BASE}/athens.jpg` },
        { from: 'TLV', to: 'IST', fromName: 'Tel Aviv', toName: 'Istanbul', img: `${IMG_BASE}/istanbul.jpg` },
        { from: 'TLV', to: 'DXB', fromName: 'Tel Aviv', toName: 'Dubai', img: `${IMG_BASE}/dubai.jpg` },
        { from: 'TLV', to: 'BKK', fromName: 'Tel Aviv', toName: 'Bangkok', img: `${IMG_BASE}/bangkok.jpg` }
      ],
      destinations: [
        { code: 'JFK', name: 'New York', countryKey: 'united_states', img: `${IMG_BASE}/new-york.jpg` },
        { code: 'LHR', name: 'London', countryKey: 'united_kingdom', img: `${IMG_BASE}/london.jpg` },
        { code: 'CDG', name: 'Paris', countryKey: 'france', img: `${IMG_BASE}/paris.jpg` },
        { code: 'FCO', name: 'Rome', countryKey: 'italy', img: `${IMG_BASE}/rome.jpg` },
        { code: 'BCN', name: 'Barcelona', countryKey: 'spain', img: `${IMG_BASE}/barcelona.jpg` },
        { code: 'ATH', name: 'Athens', countryKey: 'greece', img: `${IMG_BASE}/athens.jpg` },
        { code: 'IST', name: 'Istanbul', countryKey: 'turkey', img: `${IMG_BASE}/istanbul.jpg` },
        { code: 'DXB', name: 'Dubai', countryKey: 'uae', img: `${IMG_BASE}/dubai.jpg` },
        { code: 'BKK', name: 'Bangkok', countryKey: 'thailand', img: `${IMG_BASE}/bangkok.jpg` },
        { code: 'AMS', name: 'Amsterdam', countryKey: 'netherlands', img: `${IMG_BASE}/amsterdam.jpg` },
        { code: 'PRG', name: 'Prague', countryKey: 'czech_republic', img: `${IMG_BASE}/prague.jpg` },
        { code: 'LAX', name: 'Los Angeles', countryKey: 'united_states', img: `${IMG_BASE}/los-angeles.jpg` }
      ]
    }
  }
}
